import { SelectHotelsUser } from 'app/components'
import { useAppMainHotelSelector } from './@hooks'
import { COMPETITION_URL, FEATURES } from 'app/@common/constants'
import React, {useState} from 'react'

const ALL_HOTELS_OPTION = { value: null, label: 'All Hotels' }
const ALL_HOTELS_MODE_KEY = 'packagesAllHotelsMode'

export default function AppHeaderMainHotel({ feature, url= COMPETITION_URL.MAIN_HOTELS }) {

    const { onChange, onInit, updateMainHotels, idMainHotel, isMultiHotel, mainHotels, selectedMainHotel, isUserMaster } = useAppMainHotelSelector(feature)
    const [totalOptions, setTotalOptions] = useState(0)
    if (!isMultiHotel) return null

    const isPackages = feature === FEATURES.PACKAGES

    return <div className={`select-hotels-header ${!isUserMaster ? 'no-master' : ''}`}>
        <SelectHotelsUser
            value={mainHotels}
            onChange={({ value }) => {
                onChange(value)
            }}
            placeholder="All main hotels"
            reload={true}
            label=""
            urlAjax={url}
            onAjax={(options = []) => {
                const isAllMode = localStorage.getItem(ALL_HOTELS_MODE_KEY) === 'true'
                if (isAllMode) {
                    updateMainHotels({ mainHotels: null })
                } else {
                    onInit(parseInt(selectedMainHotel) || idMainHotel)
                }
                const enrichedOptions = isPackages ? [ALL_HOTELS_OPTION, ...options] : options
                setTotalOptions(enrichedOptions?.length)
                return enrichedOptions
            }}
            totalOptions={totalOptions}
        />
    </div>
}